// deepCopy  这个是深拷贝方法
export function deepCopy(data) {
    var type = dataType(data);
    var obj;
    if (type === "array") {
        obj = [];
    } else if (type === "object") {
        obj = {};
    } else {
        //不再具有下一层次
        return data;
    }
    if (type === "array") {
        for (var i = 0, len = data.length; i < len; i++) {
            obj.push(deepCopy(data[i]));
        }
    } else if (type === "object") {
        for (var key in data) {
            obj[key] = deepCopy(data[key]);
        }
    }
    return obj;
}

// 日期格式化
export function formatDate(time, type) {
    let date = new Date(time);

    let year = date.getFullYear();
    let mounth =
        date.getMonth() + 1 < 10 ?
        "0" + (date.getMonth() + 1) :
        date.getMonth() + 1;
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    // console.log('year',year,time)
    let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    if (type == "yyyy-MM-dd") {
        return `${year}-${mounth}-${day}`;
    }
    // return `${year}-${mounth}-${day} ${h}:${m}:${s}`;
    return `${year}-${mounth}-${day}`;
}

// 日期格式化
export function formatDate1(time, type) {
    let date = new Date(time);

    let year = date.getFullYear();
    let mounth =
        date.getMonth() + 1 < 10 ?
        "0" + (date.getMonth() + 1) :
        date.getMonth() + 1;
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    // console.log('year',year,time)
    let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    if (type == "yyyy-MM-dd") {
        return `${year}-${mounth}-${day}`;
    }
    return `${year}-${mounth}-${day} ${h}:${m}:${s}`;
    // return `${year}-${mounth}-${day}`;
}

// 日期格式化
export function formatDateYear(time, type) {
    let date = new Date(time);

    let year = date.getFullYear();
    let mounth =
        date.getMonth() + 1 < 10 ?
        "0" + (date.getMonth() + 1) :
        date.getMonth() + 1;
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    // console.log('year',year,time)
    let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    if (type == "yyyy-MM-dd") {
        return `${year}-${mounth}-${day}`;
    }
    return `${year}`;
}

export function dataType(obj) {
    var toString = Object.prototype.toString;
    var map = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regExp",
        "[object Undefined]": "undefined",
        "[object Null]": "null",
        "[object Object]": "object",
    };
    if (obj instanceof Element) {
        return "element";
    }
    return map[toString.call(obj)];
}

export const session = {
    ins: window.sessionStorage,
    get(key) {
        return this.ins.getItem(key);
    },
    set(key, value) {
        return this.ins.setItem(key, value);
    },
    remove(key) {
        return this.ins.removeItem(key);
    },
    clear() {
        this.ins.clear();
    },
};